import { OperationExpenseType } from 'views/ProFormaTable/constants';

export const UNIT_MIX_DEFAULT_NAME = 'Default name';

export const PROPERTY_TAXES = 'Property taxes';
export const OPERATING_EXPENSES = 'Operating expenses';
export const DEFAULT_EXPENSE_ANNUAL_GROWTH = 0.03;

export const INITIAL_EXPENSES = [
    {
        id: 1, name: 'Capital reserves', annualGrowth: DEFAULT_EXPENSE_ANNUAL_GROWTH, amountPerYear: 0, isDeleteAllowed: true,
    },
    {
        id: 2, name: 'Contract services', annualGrowth: DEFAULT_EXPENSE_ANNUAL_GROWTH, amountPerYear: 0, isDeleteAllowed: true,
    },
    {
        id: 3, name: 'General and administrative', annualGrowth: DEFAULT_EXPENSE_ANNUAL_GROWTH, amountPerYear: 0, isDeleteAllowed: true,
    },
    {
        id: 4, name: 'Insurance', annualGrowth: DEFAULT_EXPENSE_ANNUAL_GROWTH, amountPerYear: 0,
    },
    {
        id: 5, name: 'Make ready cost', annualGrowth: DEFAULT_EXPENSE_ANNUAL_GROWTH, amountPerYear: 0,
    },
    {
        id: 6, name: 'Management fee', annualGrowth: DEFAULT_EXPENSE_ANNUAL_GROWTH, amountPerYear: 0,
    },
    {
        id: 7, name: 'Marketing', annualGrowth: DEFAULT_EXPENSE_ANNUAL_GROWTH, amountPerYear: 0,
    },
    {
        id: 8, name: 'Other capital expenditures', annualGrowth: DEFAULT_EXPENSE_ANNUAL_GROWTH, amountPerYear: 0,
    },
    {
        id: 9, name: 'Payroll', annualGrowth: DEFAULT_EXPENSE_ANNUAL_GROWTH, amountPerYear: 0,
    },
    {
        id: 10,
        name: PROPERTY_TAXES,
        annualGrowth: DEFAULT_EXPENSE_ANNUAL_GROWTH,
        amountPerYear: 0,
        operationExpenseType: OperationExpenseType.PROPERTY_TAXES,
        isDeleteAllowed: false,
    },
    {
        id: 11, name: 'Repairs and maintenance', annualGrowth: DEFAULT_EXPENSE_ANNUAL_GROWTH, amountPerYear: 0, isDeleteAllowed: true,
    },
    {
        id: 12, name: 'Retail leasing cost reserves', annualGrowth: DEFAULT_EXPENSE_ANNUAL_GROWTH, amountPerYear: 0, isDeleteAllowed: true,
    },
    {
        id: 13, name: 'Utilities', annualGrowth: DEFAULT_EXPENSE_ANNUAL_GROWTH, amountPerYear: 0, isDeleteAllowed: true,
    },
];

export enum AreaMode {
    FAR = 'FAR',
    GROSS_BUILD_AREA = 'GROSS_BUILD_AREA'
}

export enum OperatingExpenseCalculatedOn {
    PERCENTAGE_OF_EFFECTIVE_GROSS_REVENUE = 'percentage_of_effective_gross_revenue',
    VALUE_PER_UNIT_PER_YEAR = 'value_per_unit_per_year',
    VALUE_PER_SF_PER_YEAR = 'value_per_sf_per_year',
    AMOUNT_PER_YEAR = 'amount_per_year',
    MILL_RATE = 'mill_rate',
}

export enum IncomeMiscCalculatedOn {
    AMOUNT_PER_YEAR = 'amount_per_year',
    PER_UNIT_PER_MONTH = 'value_per_unit_per_month'
}
